import React from "react";
import { FiSearch } from "react-icons/fi";

interface MealTypesFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  sortBy: "count" | "calories" | "name";
  onSortChange: (value: "count" | "calories" | "name") => void;
}

export default function MealTypesFilters({
  searchTerm,
  onSearchChange,
  sortBy,
  onSortChange,
}: MealTypesFiltersProps) {
  return (
    <div className="flex flex-col gap-3 sm:gap-4 sm:flex-row sm:items-center sm:justify-between">
      {/* Barra de Busca */}
      <div className="relative flex-1">
        <FiSearch
          className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 text-gray-400"
          size={18}
        />
        <input
          type="text"
          placeholder="Buscar tipo de refeição..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full rounded-lg sm:rounded-xl border border-stroke bg-gray-50 py-2.5 sm:py-3 pl-10 sm:pl-12 pr-4 text-sm sm:text-base font-medium outline-none transition focus:border-purple-500 focus:bg-white focus:ring-2 focus:ring-purple-500/20 dark:border-strokedark dark:bg-form-input dark:text-white dark:focus:border-purple-500"
        />
      </div>

      {/* Filtro de Ordenação */}
      <div className="relative w-full sm:w-64">
        <select
          value={sortBy}
          onChange={(e) =>
            onSortChange(e.target.value as "count" | "calories" | "name")
          }
          className="relative w-full appearance-none rounded-lg sm:rounded-xl border border-stroke bg-gray-50 py-2.5 sm:py-3 pl-3 sm:pl-4 pr-9 sm:pr-10 text-sm sm:text-base font-medium text-gray-700 outline-none transition focus:border-purple-500 focus:bg-white focus:ring-2 focus:ring-purple-500/20 dark:border-strokedark dark:bg-form-input dark:text-white dark:focus:border-purple-500"
        >
          <option value="count">Ordenar por Quantidade</option>
          <option value="calories">Ordenar por Calorias</option>
          <option value="name">Ordenar por Nome</option>
        </select>
        <span className="pointer-events-none absolute right-3 sm:right-4 top-1/2 -translate-y-1/2 text-gray-400">
          <svg className="h-4 w-4 fill-current" viewBox="0 0 24 24">
            <path d="M7 10l5 5 5-5H7z" />
          </svg>
        </span>
      </div>
    </div>
  );
}
